module.exports = __webpack_public_path__ + "img/watermark.e92bbf2d.png";